import { useMemo } from 'react';
import { IUseFilterValidationProps, IUseFilterValidationReturn } from '../type';

export const useFilterValidation = ({
  filters,
  name,
  max,
}: IUseFilterValidationProps): IUseFilterValidationReturn => {
  const validationState = useMemo(() => {
    const filtersLength = filters?.length || 0;
    const isNoError = filters.every((f) => !f.hasError);
    // 是否全选状态
    const isAllUsers = (filtersLength === 1 && !filters?.[0]?.field && !filters?.[0]?.fieldType && !filters?.[0]?.operator && !filters?.[0]?.value);
    // 筛选条件完整,最多可添加的筛选条件数量
    const canAddFilter = filtersLength < max && isNoError;
    // 筛选条件数量大于0时，可以清除
    const canClear = filtersLength > 0 && !isAllUsers;
    // 筛选条件完整且名称不为空时，可以确认
    const canConfirm = isAllUsers || (isNoError && name?.trim()?.length > 0);
    return { isNoError, isAllUsers, canAddFilter, canClear, canConfirm };
  }, [filters, name, max]);

  return validationState;
};

